/**
 * @desc 下载报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.platformReport.download.Params, options?: any) {
  return updateResponse(
    http(URL + `/platformReport/download`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
